import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Home, Search, FilePlus } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { WikiTree } from './WikiTree';

export function WikiSidebar({ sections, activeSlug, communityPages = [] }) {
  const { t } = useLanguage();

  return (
    <aside className="flex h-full w-64 shrink-0 flex-col border-r border-gray-200 bg-gray-50">
      <div className="border-b border-gray-200 p-3">
        <p className="px-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
          {t('wiki.navLabel')}
        </p>
        <div className="mt-1 space-y-0.5">
          <Link
            to="/wiki"
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100"
          >
            <Home className="h-4 w-4" />
            {t('wiki.home')}
          </Link>
          <Link
            to="/wiki/search"
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100"
          >
            <Search className="h-4 w-4" />
            {t('wiki.search')}
          </Link>
          <Link
            to="/wiki/glossary"
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100"
          >
            <BookOpen className="h-4 w-4" />
            {t('wiki.glossary')}
          </Link>
          <Link
            to="/wiki/drafts"
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-gray-700 hover:bg-gray-100"
          >
            <FilePlus className="h-4 w-4" />
            {t('wiki.myDrafts')}
          </Link>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-2 pb-4">
        {sections.map((section) => (
          <div key={section.id} className="mb-4">
            <p className="px-2 py-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
              {section.title}
            </p>
            <WikiTree tree={section.nodes} activeSlug={activeSlug} />
          </div>
        ))}
        {communityPages.length > 0 && (
          <div className="mb-4">
            <p className="px-2 py-2 text-xs font-semibold uppercase tracking-wide text-gray-400">
              {t('wiki.communityPages')}
            </p>
            <div className="space-y-0.5">
              {communityPages.map((p) => (
                <Link
                  key={p.slug}
                  to={`/wiki/${p.slug}`}
                  className={`block rounded-md px-2 py-1.5 text-sm hover:bg-gray-100 ${
                    activeSlug === p.slug ? 'bg-gray-200 font-medium text-gray-900' : 'text-gray-700'
                  }`}
                >
                  {p.title}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
}
